import { useEffect, useLayoutEffect } from "react";

import {
  applyThemeColorScheme,
  getSystemColorScheme,
  initializeThemePreference,
  themeStore,
} from "../domain";

const useIsomorphicLayoutEffect =
  typeof window === "undefined" ? useEffect : useLayoutEffect;

export function useThemePreferenceSync() {
  useIsomorphicLayoutEffect(() => {
    initializeThemePreference();

    const unsubscribe = themeStore.subscribe((state) => {
      applyThemeColorScheme(state.effectiveColorScheme);
    });

    if (typeof window === "undefined") {
      return unsubscribe;
    }

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const syncSystemColorScheme = () => {
      themeStore.getState().setSystemColorScheme(getSystemColorScheme());
    };

    syncSystemColorScheme();
    mediaQuery.addEventListener("change", syncSystemColorScheme);

    return () => {
      unsubscribe();
      mediaQuery.removeEventListener("change", syncSystemColorScheme);
    };
  }, []);
}
